import Repository from './Repository.js';

class ParametersRepository extends Repository {
    async getParameters(query) {
        return await this.get('parameters', query);
    }
}

export default new ParametersRepository();
